<div class="ticker-search-result-list">
  <app-search-bar (searchEvent)="onSearch($event)" [searching]="searching"></app-search-bar>
  <app-search-result-item
    *ngFor="let result of searchResults"
    [ticker]="result"
  ></app-search-result-item>
  <div *ngIf="searchResults.length === 0 && query && !searching">No symbols found</div>
</div>
